import { render, staticRenderFns } from "./transcript-summary-panel.vue?vue&type=template&id=332c26b0&scoped=true&"
import script from "./transcript-summary-panel.vue?vue&type=script&lang=js&"
export * from "./transcript-summary-panel.vue?vue&type=script&lang=js&"
import style0 from "./transcript-summary-panel.vue?vue&type=style&index=0&id=332c26b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c26b0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332c26b0')) {
      api.createRecord('332c26b0', component.options)
    } else {
      api.reload('332c26b0', component.options)
    }
    module.hot.accept("./transcript-summary-panel.vue?vue&type=template&id=332c26b0&scoped=true&", function () {
      api.rerender('332c26b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-summary-panel/transcript-summary-panel.vue"
export default component.exports